import * as React from 'react';
import { 
  Box,
  CircularProgress,
  DialogContent,
  IconButton,
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton } from '../../components/common/Modal';
import MultiSelect from '../../components/common/MultiSelect';

import { getSources } from '../../slices/source';
import { assignSourceToGroup } from '../../slices/group';

export default function AssignSourceModal(props) {
  const {open, type, group, defaultValue, handleClose} = props;
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [data, setData] = React.useState(defaultValue);

  const dispatch = useDispatch();  

  React.useEffect(() => {
    let formData = new FormData();
    formData.append("page", 1);

    dispatch(getSources(formData))
      .unwrap()
      .then(data => {
        const newSources = data.map(item => ({ name: item.name})); // Assuming MultiSelect uses 'value'
        setOptions(newSources);
        setLoading(false); // Set loading to false after fetching
      })
      .catch(err => {
        console.log(err);
        setLoading(false); // Set loading to false on error
      });
  }, [dispatch]);

  // Update data when the modal opens
  React.useEffect(() => {
    if (open) {
      setData(defaultValue); // Update data with defaultValue when modal opens
    }
  }, [open, defaultValue]);

 
const handleSave = (e) => {
    setLoading(true);
    const sources = data.map(item => item.name);
    let formData = new FormData();
    formData.append('group', group);
    formData.append('db', sources);
    dispatch(assignSourceToGroup(formData))
      .then(res => {
        window.alert("Create new user successfully!");
        setLoading(false);
        handleClose();
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      }
    )
  }

  const handleData = (values) => {
    setData(values);
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
      >
        <CDialogTitle>{`Assign ${type}`}</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" style={{ height: '100px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <MultiSelect
              label={type}
              options={options} 
              value={data}
              handleChange={handleData}
            />
          )}
        </DialogContent>
        <CDialogActions>
          <CButton onClick={() => {handleClose();}}>Cancel</CButton>
          <CButton onClick={handleSave}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}